import React from "react";
import { Label, Divider, Grid, Header } from "semantic-ui-react";
import { get, isEmpty } from "lodash";

import AppLink from "../Common/AppLink";
import DeleteModal from "../Common/DeleteModal";

export const DiscountList = ({ discounts, defaultCurrency }) => {
  return (
    <Grid padded>
      <Grid.Row verticalAlign="middle" columns={3}>
        <Grid.Column textAlign="left" width={2}>
          <h3>DISCOUNTS</h3>
        </Grid.Column>
        <Grid.Column>
          <Label size="large" circular color="black" data-test="count_visible_records">
            {get(discounts, "length", 0)}
          </Label>
        </Grid.Column>
        <Grid.Column width={5} />
        <Grid.Column width={3} textAlign="right">
          <AppLink to="/discounts/new" icon="add" background content="New Discount" data-test="new_discount_button" />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={6} data-test="table_header">
        <Grid.Column width={3} as={Header} size="small" textAlign="left" data-test="name">
          Name (slug)
        </Grid.Column>
        <Grid.Column width={2} as={Header} size="small" textAlign="left" data-test="netsuite_id">
          Item (Netsuite product ID)
        </Grid.Column>
        <Grid.Column width={2} as={Header} size="small" textAlign="left" data-test="product">
          On <br /> Product / <br /> ProductGroup
        </Grid.Column>
        <Grid.Column width={2} as={Header} size="small" textAlign="left" data-test="customer">
          For <br /> Customer / <br /> CustomerGroup
        </Grid.Column>
        <Grid.Column width={1} as={Header} size="small" textAlign="right" data-test="amount">
          Amount
        </Grid.Column>
        <Grid.Column width={2} as={Header} size="small" textAlign="right" data-test="type">
          Type
        </Grid.Column>
        <Grid.Column width={2} />
        <Grid.Column width={2} as={Header} size="small" textAlign="left" data-test="actions">
          Actions
        </Grid.Column>
      </Grid.Row>
      <Divider />

      {!isEmpty(discounts) &&
        discounts.map(
          (discount, index) =>
            discount.discountableProduct &&
            discount.discountableCustomer && (
              <DiscountRow row={index} discount={discount} defaultCurrencies={defaultCurrency} key={index} />
            )
        )}

      {isEmpty(discounts) && (
        <Grid.Row textAlign="center">
          <Grid.Column data-test="not_found">No discounts</Grid.Column>
        </Grid.Row>
      )}
    </Grid>
  );
};

const DiscountRow = ({ row, discount, defaultCurrencies }) => (
  <Grid.Row data-test={`discounts-tr-${row}`} columns={6}>
    <Grid.Column width={3} textAlign="left" data-test="name">
      {discount.name} ({discount.slug})
    </Grid.Column>
    <Grid.Column width={2} textAlign="left" data-test="netsuite_id">
      {discount.item}
    </Grid.Column>
    <Grid.Column width={2} textAlign="left" data-test="product">
      {discount.discountableProduct.name} ({discount.discountableProductType})
    </Grid.Column>
    <Grid.Column width={2} textAlign="left" data-test="customer">
      {discount.discountableCustomer.company || discount.discountableCustomer.name} ({discount.discountableCustomerType})
    </Grid.Column>
    <Grid.Column width={1} textAlign="center" data-test="amount">
      {discount.discountFixedAmounts.length === 0
        ? discount.amount
        : discount.discountFixedAmounts.find(item => item.currency == defaultCurrencies).amount + " " + defaultCurrencies}
    </Grid.Column>
    <Grid.Column width={2} textAlign="right" data-test="type">
      {discount.discountType === "percentage" ? "Percentage" : "Fixed"}
    </Grid.Column>
    <Grid.Column width={4} textAlign="right">
      <Grid>
        <Grid.Row columns={2}>
          <Grid.Column textAlign="right">
            <AppLink
              data-test="discountEditButton"
              icon="edit"
              size="large"
              to={`/discounts/${discount.id}/edit`}
              content="Edit"
            />
          </Grid.Column>
          <Grid.Column textAlign="left">
            <DeleteModal
              data-test="discountDeleteButton"
              recordSlug={discount.id}
              recordName={discount.name}
              resourceName="discounts"
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Grid.Column>
  </Grid.Row>
);

export default DiscountList;
